module.exports = __webpack_public_path__ + "static/bishop-what-we-do-logo-4a456e8347a0fe1dffa059a3efbd8615.png";